import { motion } from "framer-motion";
import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function EmailCapture() {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/leads", {
        email,
        first_name: firstName || null,
        source: "prompt_guide",
      });
      setSent(true);
      toast.success("Check your inbox — your prompt guide is on the way.");
      setEmail("");
      setFirstName("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="email-capture"
      data-testid="email-capture-section"
      className="py-24 md:py-40 px-6 md:px-12 lg:px-20"
      style={{ background: "#FAF9F6" }}
    >
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20 items-start">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-6"
        >
          <span className="overline" data-testid="email-overline">Complimentary · A Gift</span>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-6 leading-[1.05]">
            The Findaura <em>Prompt</em> Guide, on us.
          </h2>
          <div className="gold-hair mt-8" />
          <p className="mt-8 max-w-md text-[15px] leading-relaxed text-[#5C5A56]">
            Twenty of our most-loved prompts — for content, admin, wardrobe planning, and quiet Sunday resets.
            Delivered instantly to your inbox.
          </p>
        </motion.div>

        <motion.form
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.2, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-6 card-luxe"
          onSubmit={submit}
          data-testid="email-capture-form"
        >
          {sent ? (
            <div className="text-center py-8">
              <span className="overline">Received</span>
              <p className="font-serif italic text-3xl mt-4">Beautifully done.</p>
              <p className="mt-3 text-sm text-[#5C5A56]">Check your inbox in the next few minutes.</p>
            </div>
          ) : (
            <>
              <label className="overline block" htmlFor="email-first-name">Your first name</label>
              <input
                id="email-first-name"
                data-testid="email-first-name-input"
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="input-editorial mt-2"
                placeholder="e.g. Aurora"
              />

              <label className="overline block mt-8" htmlFor="email-address">Email address</label>
              <input
                id="email-address"
                data-testid="email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-editorial mt-2"
                placeholder="you@softlife.com"
              />

              <button
                type="submit"
                disabled={loading}
                className="btn-primary mt-10"
                data-testid="email-submit-button"
              >
                {loading ? "Sending…" : "Send Me the Guide"}
                <span aria-hidden>→</span>
              </button>

              <p className="mt-6 text-xs tracking-widest uppercase text-[#5C5A56]">
                No spam. Unsubscribe with grace, anytime.
              </p>
            </>
          )}
        </motion.form>
      </div>
    </section>
  );
}
